import axios from 'axios';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';

const useSaveChangesIdCard = ({ onModalClose }) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(
    async ({ idCardEditedData, idCardImages }) => {
      const validIdCardImages = idCardImages.filter((image) => !!image.imageId);
      idCardEditedData.images = validIdCardImages;
      return await axios.patch(`/idcards/${idCardEditedData.id}`, idCardEditedData);
    },
    {
      onSuccess: (res, { idCardEditedData }) => {
        queryClient.invalidateQueries('idCards', { exact: true });
        queryClient.invalidateQueries(['idCards', { tagId: idCardEditedData.tagId }], { exact: true });
        toast.success('Changes Saved', {
          position: toast.POSITION.TOP_LEFT,
        });
        onModalClose();
      },
    }
  );

  return {
    saveChanges: mutate,
    isLoading,
  };
};

export default useSaveChangesIdCard;
